export default "__VITE_ASSET__CPjsUBIe__"